




import { Vue, Component } from "vue-property-decorator";
import { vxm } from "@/store";

@Component({})
export default class App extends Vue {
  get pageLoaded() {
    return vxm.app.pageLoaded;
  }
}
